import { useSessionStore } from "Common/Stores";
import { layoutStore } from "Layout/VerticalLayout/store/layoutMenu.store";
import { useNavigate } from "react-router-dom";

export const useLogout = () => {
  const { clearSession } = useSessionStore();
  const navigate = useNavigate();

  const logout = () => {
    layoutStore.getState().clearCache?.();
    localStorage.removeItem("layout-menu-cache");
    clearSession();
    navigate("/login");
  };

  return {
    logout,
  };
};
